import { render, staticRenderFns } from "./CardListKunjungan.vue?vue&type=template&id=1a368cb1&scoped=true&"
import script from "./CardListKunjungan.vue?vue&type=script&lang=ts&"
export * from "./CardListKunjungan.vue?vue&type=script&lang=ts&"
import style0 from "./CardListKunjungan.vue?vue&type=style&index=0&id=1a368cb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a368cb1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDataTable,VIcon})
